import { Observable } from 'rxjs';
import { anexoRemisionRequest } from '../../../../infraestructure/request-model/remision/anexos.remisiones.request';
import { ConsultarRemisionesFurRequest } from '../../../../infraestructure/request-model/remision/consultar-remisiones-fur.request';
import { FiltrosInformeRemisionesRequest } from '../../../../infraestructure/request-model/remision/filtros-informe-remisiones.request';
import { FiltrosRemisionesRequest } from '../../../../infraestructure/request-model/remision/filtros-remisiones.request';
import { Valoracion } from '../../maestro/entity/valoracion.model';
import { Admision } from '../entity/admision.model';
import { PlanManejo } from '../entity/plan-manejo/plan-manejo.model';


export abstract class RemisionGatewayAbstract {
  abstract guardarRemision(data: any): Observable<string>;

  abstract admitir(data: any): Observable<any>;

  abstract admitirFur(data: any): Observable<any>;

  abstract getRemisionesFur(consultarRemisionesFurRequest: ConsultarRemisionesFurRequest): Observable<any>;

  abstract migrarRemisionesFur(listaRemisiones: any[]): Observable<any>;

  abstract obtenerPisosFur(): Observable<any>;
  abstract obtenerProgramasFur(): Observable<any>;


  abstract getRemisiones(filtroslistaRemisiones: FiltrosRemisionesRequest): Observable<any>;

  abstract consultarEstadoActualRemisionPorIdRemisionYUsuario(idRemision: string, usuario: string, estado?: string): Observable<any>;

  abstract modificarBloqueoRemision(idRemision: string, bloqueo: boolean): Observable<any>;

  abstract getRemisionesInforme(filtroslistaRemisiones: FiltrosInformeRemisionesRequest): Observable<any>;

  abstract generarRemision(): Observable<any>;

  abstract getReporteRemision(idRemisionPk: string): Observable<any>;

  abstract getagregadoPaciente(idRemisionPk: string): Observable<any>;

  abstract getagregadoDatosDeAtencion(idRemisionPk: string): Observable<any[]>;

  abstract getagregadoRemision(idRemisionPk: string): Observable<any[]>;

  abstract getAgregadoDiagnostico(idRemision: string): Observable<any[]>;

  abstract getAgregadoDiagnosticoEspeciales(idRemision: string): Observable<any[]>;

  abstract getAgregadoDatosRemision(idRemision: string): Observable<any[]>;

  abstract getValoraciones(): Observable<Valoracion[]>;

  abstract getValoracionesPorTipo(tipo: string): Observable<Valoracion[]>;

  abstract getPlanManejoAgregado(idRemision: string): Observable<PlanManejo>;

  abstract getAdmisionAgregado(idRemision: string): Observable<Admision>;

  abstract cargarAnexo(request: anexoRemisionRequest): Observable<any>;

  abstract consultarDocumentosPorRemisionYdocumento(idRemision: string, tipoDocumento: string, codigoSura: string, documento: string): Observable<any>

  abstract consultarDocumentoPorId(idDocumento): Observable<any>;

  abstract gestionarNovedadesActivacion(ciudad: string): Observable<any>;


}
